import React from 'react';
import { Navigate } from 'react-router';
import Base from '../Base';

export default class CrmCaseLogs extends Base {
    constructor(props) {
        super(props);
        this.state = {
            personId: this.isNull(props.PersonId) ? this.defaultGuid() : props.PersonId,
            data: null,
            loading: true,
        };
        this.keyDownFunction = this.keyDownFunction.bind(this);
    }
    componentWillUnmount() {
        this.removeKeyDown();
    }
    componentDidMount() {
        this.addKeyDown();

        var p1 = this.httpPost("api/v1/crm/case/alllogs", {
            personId: this.state.personId
        })
            .then(data => {
                if (data.status === -1) window.location.href = "/login";
                if (data.status === 1) {
                    window.companyId = data.global.company.id;
                    this.state.data = data;
                }
            });

        Promise.all([p1]).then(r => {
            this.setState({
                loading: false
            })
        })
    }
    renderForm() {
        return  <div className="row g-gs mb-4">
            {this.state.data.record.map((record, index) => <div className="col-sm-12 col-lg-12 col-xxl-3" style={{ "margin-top": "5px" }}>
                    <div className="card card-bordered h-100">
                        <div className="card-inner">
                            <div className="project">
                                <div>
                                    <a className="hand project-title">
                                        <div className="project-info">
                                            <h6 className="title">
                                                {record.userName} {!this.isBlank(record.kartablName) && [<em className="icon ni ni-chevron-right-circle"></em>, " " + record.kartablName]}
                                                <span className="badge rounded-pill bg-danger">{record.typeString}</span>
                                                <span className="badge rounded-pill bg-primary">{record.contactTypeString}</span>
                                            </h6>
                                            {!this.isBlank(record.personActionString) && <p>{record.personActionString}</p>}
                                            {(!this.isBlank(record.currentStatusString) || !this.isBlank(record.nextStatusString)) && <p>{record.currentStatusString} <em className="icon ni ni-chevron-right-circle"></em> {record.nextStatusString}</p>}
                                        <span style={{ "position": "absolute", "left": "1rem", "top": "1rem" }} className="sub-text"><em className="icon ni ni-calender-date"></em> {record.date}</span>
                                        {!this.isBlank(record.dueDate) && <span style={{ "position": "absolute", "left": "1rem", "top": "3rem" }} className="text-warning"><em className="icon ni ni-calender-date"></em> {record.date}</span>}
                                            {!this.isBlank(record.attachmentUrl) && <a href={record.attachmentUrl} target="_blank">مشاهده فایل پیوست</a>}
                                        </div>
                                    </a>
                                </div>
                                <div className="project-details">
                                    {record.fieldValues.map(record => <p><b>{record.title}: </b>{record.value}</p>)}
                                    <p>{record.description}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </div>
    }
    render() {
        if (!this.isBlank(this.state.redirect)) return <Navigate to={this.state.redirect} />

        let contents = this.state.loading ? this.renderLoading() :
            [
                this.state.lockScreen === 1 && this.lockScreen(),
                this.getGlobalContainer(),
                this.renderForm(),
                this.renderPopupComponent(),
            ];
        return contents;
    }
}